import { useRoutes } from 'react-router-dom'
import { LoginScreen } from './screens/LoginScreen'
import { MainRoutes } from './layouts/routes/MainRoutes'
import { AppRoutesRouter } from './app-routes'
import { UserRegistrationScreen } from './screens/UserRegistrationScreen'
import { RegistrationCompleteScreen } from './screens/RegistrationCompleteScreen'
import MapPage from './pages/MapPage'
import ProjectMapContainer from './screens/project/ProjectMapContainer'

export const MainRouter = () => {
  return useRoutes([
    { path: AppRoutesRouter.Login, element: <LoginScreen /> },
    { path: AppRoutesRouter.RegisterComplete, element: <RegistrationCompleteScreen /> },
    { path: AppRoutesRouter.UserRegistration, element: <UserRegistrationScreen /> },
    { path: AppRoutesRouter.MapPage, element: <MapPage /> },
    { path: AppRoutesRouter.ProjectMap, element: <ProjectMapContainer /> },
    {
      path: '/*',
      element: <MainRoutes />,
    },
  ])
}
